import { FiscalCfop } from './../../model/fiscal/fiscalCfop';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { GenericService } from '../generics/generic.service';
import { AutoRegisterService } from '../generics/servicesRegistry';

@Injectable({
  providedIn: 'root'
})
@AutoRegisterService()
export class FiscalCfopService extends GenericService<FiscalCfop> {
  constructor(http: HttpClient) {
    super(http);
    super.initResource("fiscalcfop")
  }
}
